/**
 * Turn a Google Maps share URL, iframe snippet, or place name into an iframe src.
 * Official Google embed URLs (/maps/embed?pb=) are kept.
 * Place names and the old output=embed URLs use OpenStreetMap (Google blocks keyless embeds).
 */
export const ISLAMABAD_MAP_EMBED =
  'https://www.openstreetmap.org/export/embed.html?bbox=72.90000%2C33.52000%2C73.22000%2C33.82000&layer=mapnik&marker=33.68440%2C73.04790';

function osmFromCoords(lat, lon, span = 0.12) {
  const minLon = lon - span;
  const maxLon = lon + span;
  const minLat = lat - span * 0.7;
  const maxLat = lat + span * 0.7;
  const bbox = encodeURIComponent(
    `${minLon.toFixed(5)},${minLat.toFixed(5)},${maxLon.toFixed(5)},${maxLat.toFixed(5)}`
  );
  const marker = encodeURIComponent(`${lat.toFixed(5)},${lon.toFixed(5)}`);
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;
}

function osmFromPlace(query) {
  const key = String(query || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (!key || key.includes('islamabad')) {
    return ISLAMABAD_MAP_EMBED;
  }
  return ISLAMABAD_MAP_EMBED;
}

export function toGoogleMapsEmbed(raw, fallback = ISLAMABAD_MAP_EMBED) {
  let value = String(raw || '').trim();
  if (!value) {
    return fallback;
  }

  value = value.replace(/&amp;/g, '&').replace(/\s+/g, ' ');

  const srcMatch =
    value.match(/src\s*=\s*["']([^"']+)["']/i) ||
    value.match(/src\s*=\s*([^\s>]+)/i);
  let url = srcMatch ? srcMatch[1].replace(/^["']|["']$/g, '') : value;

  if (url.includes('<')) {
    url = url.replace(/<[^>]+>/g, '').trim();
  }

  if (/maps\.app\.goo\.gl|goo\.gl\/maps/i.test(url)) {
    return fallback;
  }

  if (/openstreetmap\.org\/export\/embed/i.test(url)) {
    return url;
  }

  if (/google\.[^/]+\/maps\/embed/i.test(url)) {
    return url;
  }

  const place = url.match(
    /google\.[^/]+\/maps\/place\/([^/@]+)\/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/i
  );
  if (place) {
    return osmFromCoords(Number(place[2]), Number(place[3]));
  }

  const coord = url.match(
    /google\.[^/]+\/maps\/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/i
  );
  if (coord) {
    return osmFromCoords(Number(coord[1]), Number(coord[2]));
  }

  const qMatch = url.match(/[?&]q=([^&]+)/i);
  if (qMatch) {
    return osmFromPlace(decodeURIComponent(qMatch[1].replace(/\+/g, ' ')));
  }

  if (!/^https?:\/\//i.test(url)) {
    return osmFromPlace(url);
  }

  const pathPlace = url.match(/\/maps\/place\/([^/?#]+)/i);
  if (pathPlace) {
    return osmFromPlace(decodeURIComponent(pathPlace[1].replace(/\+/g, ' ')));
  }

  if (/output=embed/i.test(url)) {
    return osmFromPlace(url);
  }

  return fallback;
}

export default toGoogleMapsEmbed;
